// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
import Charts from 'src/components/Dashboard/Views/Charts.vue'
// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'
import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue'
// Forms pages
import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue'
import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue'
import Wizard from 'src/components/Dashboard/Views/Forms/Wizard.vue'
import FullScreenMap from 'src/components/Dashboard/Views/Maps/FullScreenMap.vue'
// Maps pages
import GoogleMaps from 'src/components/Dashboard/Views/Maps/GoogleMaps.vue'
import VectorMaps from 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'
// import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue'
import PaginatedTables from 'src/components/Dashboard/Views/Tables/PaginatedTables.vue'
// TableList pages
import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue'
import Commands from 'src/pages/Commands/Commands'
import CommandsIndex from 'src/pages/Commands/CommandsIndex'
import ListAttachments from 'src/pages/Commands/ListAttachments'
import Dashboard from 'src/pages/Dashboard/Dashboard.vue'

// Printing
import TicketPrint from 'src/pages/Documents/DocumentTicket'
import LampsDocument from 'src/pages/Documents/Terms/LampsDocument'
import Login from 'src/pages/Login/Login.vue'
import DocumentsPrint from 'src/pages/Documents/DocumentsPrint'
import AllTicketsDocument from 'src/pages/Documents/AllTicketsDocument'
import DocumentTicketEquatorial from '../pages/Documents/DocumentTicketEquatorial'
import DocTicketRegister from '../components/Trg/Documents/TicketsRegister/DocTicketRegister'
import Print from 'src/pages/Tickets/Print'
import RankingPrintWinners from 'src/pages/Ranking/RankingPrintWinners'
// Layouts
import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import CustomersMenu from './routes/customers'
import EventsMenu from './routes/events'
import EventsSpecificationsMenu from './routes/eventsSpecifications'
import StatusReplicationMenu from './routes/statusReplication'
import ManufacturersMenu from './routes/manufacturers'
import ProjectMenu from './routes/project'
import ReportsMenu from './routes/reports'
import PermissionsMenu from './routes/roles'
import StockMenu from './routes/stock'
import UsersMenu from './routes/users'
import SyncMenu from './routes/sync'
import TagMenu from './routes/tag'
import ApiMenu from './routes/api'
import SurveysRoutes from './routes/surveys'

import Categories from './routes/categories'

let configurationsMenu = {
  path: '/configurations',
  component: DashboardLayout,
  redirect: '/configurations/users',
  children: [
    UsersMenu,
    ProjectMenu,
    ManufacturersMenu,
    PermissionsMenu,
    TagMenu,
    ApiMenu,
    Categories
  ]
}

let manageMenu = {
  path: '/manage',
  component: DashboardLayout,
  redirect: '/manage/events',
  children: [
    EventsMenu,
    EventsSpecificationsMenu,
    CustomersMenu,
    StockMenu,
    ReportsMenu,
    SyncMenu,
    StatusReplicationMenu
  ]
}

let a = SurveysRoutes

let documentsRoutes = {
  path: '/print',
  component: Print,
  children: [
    {
      path: `ticket/register/print/:id`,
      name: `tickets.register.print`,
      component: DocTicketRegister,
      meta: {
        title: 'Ticket',
        requireAuth: true
      }
    },
    {
      path: `ticket/:id`,
      name: `tickets.print`,
      component: TicketPrint,
      meta: {
        title: 'Ticket',
        requireAuth: true
      }
    },
    {
      path: `documents/:eventId/:ticketId`,
      name: `documents.print`,
      component: DocumentsPrint,
      meta: {
        title: 'Documentos',
        requireAuth: true
      }
    },
    {
      path: `lamps/term`,
      name: `lamps.print`,
      component: LampsDocument,
      meta: {
        title: 'Lâmpadas',
        requireAuth: true
      }
    },
    {
      path: 'event/:id/ranking/winners/print',
      name: 'ranking.print.winners',
      component: RankingPrintWinners,
      meta: {
        title: {
          requireAuth: true
        }
      }
    },
    {
      path: 'tickets/event/:id/:eligibleNotWinners',
      name: 'all.tickets.documents.print',
      component: AllTicketsDocument,
      meta: {
        title: {
          requireAuth: true
        }
      }
    },
    {
      path: 'tickets/equatorial/:eventId/:ticketId',
      name: 'document.ticket.equatorial',
      component: DocumentTicketEquatorial,
      meta: {
        title: {
          requireAuth: true
        }
      }
    }
  ]
}

let commandsRoutes = {
  path: '/commands',
  component: DashboardLayout,
  children: [
    {
      path: '',
      component: Commands,
      children: [
        {
          path: '',
          name: `commands.index`,
          component: CommandsIndex,
          meta: {
            title: 'Commands',
            requireAuth: true
          }
        },
        {
          path: 'list-attachments/:connection',
          name: `commands.listAttachments`,
          component: ListAttachments,
          meta: {
            title: 'Listar Attachments',
            requireAuth: true
          }
        }
      ]
    }
  ]
}

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }
  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}
let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }
  ]
}
let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}
let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}
let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}
let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}
let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/login',
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      }
    ]
  },
  a,
  documentsRoutes,
  commandsRoutes,
  configurationsMenu,
  manageMenu,
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  loginPage,
  registerPage,
  lockPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard.overview',
        component: Dashboard,
        meta: {
          title: 'Dashboard',
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/theme',
    children: [
      {
        path: 'theme',
        name: 'Overview',
        component: Overview,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'stats',
        name: 'Stats',
        component: Stats
      }
    ]
  },
  {
    path: '*',
    component: NotFound
  }
]
/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js